module.exports = __webpack_public_path__ + "static/img/hala21.ceb749b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hala/hala21.jpg
// module id = VmSb
// module chunks = 1